import { defineComponent as P, computed as $, createElementBlock as s, openBlock as i, createElementVNode as n, withDirectives as L, normalizeClass as O, createCommentVNode as l, createBlock as d, Fragment as A, createVNode as h, unref as r, normalizeStyle as f, mergeProps as D, toDisplayString as E, renderSlot as k, vShow as I } from "vue";
import { GuideIcon as b } from "@scalar-org/guide-icons";
import { ScalarIconCaretRight as v, ScalarIconArrowUpRight as N } from "@scalar/icons";
const V = { class: "sidebar-group-item" }, z = {
  key: 0,
  class: "sidebar-heading-chevron"
}, R = ["aria-controls", "aria-expanded"], T = { class: "sidebar-heading-link-title" }, G = {
  key: 2,
  class: "action-menu"
}, U = ["id"], J = /* @__PURE__ */ P({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(C, { emit: F }) {
    const t = C, a = F, S = $(() => {
      var o;
      const e = t.item;
      return e.type === "Link" ? {
        href: e.link,
        rel: "noopener noreferrer",
        target: "_blank"
      } : e.type === "Page" ? {
        href: ((o = t.resolvePage) == null ? void 0 : o.call(t, e.uid)) || "#"
      } : {};
    });
    function w() {
      if (t.item.type !== "Link") {
        if (t.item.type === "Folder") {
          a("toggleOpen");
          return;
        }
        a("select");
      }
    }
    function B() {
      t.item.type !== "Folder" && a("toggleOpen");
    }
    return (e, o) => {
      var c, p, m, u, g;
      return i(), s("li", V, [
        n("div", {
          class: O(["sidebar-heading", {
            active_page: e.isActive,
            "sidebar-group-item__folder": e.item.type === "Folder"
            /* Folder */
          }]),
          onClick: w
        }, [
          e.hasChildren || e.item.type === "Folder" ? (i(), s("p", z, [
            n("button", {
              "aria-controls": `${e.item.uid}-content`,
              "aria-expanded": e.open,
              class: "toggle-nested-icon",
              type: "button",
              onClick: B
            }, [
              o[1] || (o[1] = n("span", { class: "sr-only" }, "Toggle group", -1)),
              (p = (c = e.item) == null ? void 0 : c.icon) != null && p.src ? (i(), s(A, { key: 0 }, [
                h(r(b), {
                  class: "sidebar-icon",
                  src: e.item.icon.src
                }, null, 8, ["src"]),
                h(r(v), {
                  class: "sidebar-icon-caret hidden",
                  style: f({
                    transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                  }),
                  weight: "bold"
                }, null, 8, ["style"])
              ], 64)) : (i(), d(r(v), {
                key: 1,
                style: f({
                  transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                }),
                weight: "bold"
              }, null, 8, ["style"]))
            ], 8, R)
          ])) : l("", !0),
          n("a", D({ class: "sidebar-heading-link flex-1" }, S.value, {
            onClick: o[0] || (o[0] = (y) => e.item.type === "Link" ? y.stopPropagation() : y.preventDefault())
          }), [
            (u = (m = e.item) == null ? void 0 : m.icon) != null && u.src && e.item.type !== "Folder" ? (i(), d(r(b), {
              key: 0,
              class: "sidebar-icon",
              src: e.item.icon.src
            }, null, 8, ["src"])) : l("", !0),
            n("p", T, E(e.item.title.trim() || e.item.type), 1)
          ], 16),
          ((g = e.item) == null ? void 0 : g.type) === "Link" ? (i(), d(r(N), {
            key: 1,
            class: "link-icon",
            weight: "bold"
          })) : l("", !0),
          e.$slots["action-menu"] ? (i(), s("div", G, [
            k(e.$slots, "action-menu", {}, void 0, !0)
          ])) : l("", !0)
        ], 2),
        L(n("div", {
          id: `${e.item.uid}-content`,
          class: "contents"
        }, [
          k(e.$slots, "default", {}, void 0, !0)
        ], 8, U), [
          [I, e.open]
        ])
      ]);
    };
  }
});
export {
  J as default
};
